<template>
  <div class="article-categories-filter">
    <div v-if="showTitle" class="categories-title">Рубрики</div>
    <div class="categories-list">
      <div
          v-for="category in categories"
          :key="category.id"
          class="category-item"
          :class="{ '-active': category.id === selectedId }"
          @click="toggle(category)"
      >
        <div class="icon-wrapper">
          <img v-if="category.image" :src="category.image" :alt="category.name">
        </div>
        <span class="name">{{ category.name }}</span>
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
import type { ArticleFilterOption } from '~/models/articles'

const props = defineProps<{
  categories: ArticleFilterOption[]
  initialRubricId?: string
  showTitle?: boolean
}>()

const emit = defineEmits<{
  (e: 'on-change', value: { rubric_id?: string }): void
}>()

const selectedId = ref<number | null>(null)

function syncFromProps() {
  const id = props.initialRubricId ? Number(props.initialRubricId) : null
  selectedId.value = id && props.categories.some(c => c.id === id) ? id : null
}

watch(() => props.initialRubricId, syncFromProps)
watch(() => props.categories, syncFromProps, { immediate: true })

function toggle(category: ArticleFilterOption) {
  selectedId.value = selectedId.value === category.id ? null : category.id
  emit('on-change', { rubric_id: selectedId.value ? String(selectedId.value) : undefined })
}
</script>

<style lang="scss" scoped>
.article-categories-filter {
  @extend %flex-column;

  gap: 12px;

  > .categories-title {
    font-size: 20px;
    font-weight: 500;
    margin-bottom: 8px;

    @include vp-767 {
      font-size: 16px;
    }
  }

  > .categories-list {
    @extend %flex-column;

    gap: 8px;

    > .category-item {
      display: flex;
      align-items: center;
      gap: 12px;
      padding: 8px 10px;
      border-radius: 12px;
      cursor: pointer;
      transition: background 0.15s;

      &.-active {
        background: $color-kiwi-20;
      }

      > .icon-wrapper {
        width: 40px;
        height: 40px;
        border-radius: 8px;
        overflow: hidden;
        background: $main-back-color;
        display: flex;
        align-items: center;
        justify-content: center;
        flex-shrink: 0;

        @include vp-767 {
          width: 36px;
          height: 36px;
          border-radius: 6px;
        }

        > img {
          width: 100%;
          height: 100%;
          object-fit: contain;
        }
      }

      > .name {
        font-size: 16px;
        color: $color-default-black;
      }
    }
  }
}
</style>
